import { useQueryClient, type MutationFunction } from "@tanstack/react-query";
import type { TransactionDetailsModel } from "@/features/collections/api/models/TransactionDetailsModel";
import { clearCacheAfterTransactionMutation } from "@/features/collections/api/clearCacheAfterTransactionMutation";
import { patchTransactionAfterMutation } from "@/features/collections/api/patchTransactionAfterMutation";
import { paginatedRemove, useHTTP, useHTTPMutation, type HTTPResponse } from "@/lib/http";

export interface TransactionDeleteRequestProperties {
	readonly transactionId: string;
	readonly collectionId: string;
	readonly variantId: string;
}

export const useTransactionDelete = () => {
	const http = useHTTP("Required");
	const queryClient = useQueryClient();

	const mutationFn: MutationFunction<HTTPResponse<undefined>, TransactionDeleteRequestProperties> = requestProperties => {
		return http({
			method: "DELETE",
			url: `/transaction/${requestProperties.transactionId}`
		});
	};

	return useHTTPMutation({
		mutationFn,
		onSuccess: (_, requestProperties) => {
			patchTransactionAfterMutation(
				queryClient,
				requestProperties.collectionId,
				requestProperties.variantId,
				paginatedRemove<TransactionDetailsModel>(x => x.transactionId === requestProperties.transactionId)
			);
			clearCacheAfterTransactionMutation(queryClient, requestProperties.collectionId, requestProperties.variantId);
		}
	});
};
